import React from "react"
import Grid from '@mui/material/Grid'
import SimpleTextField from "../../../../../components/Forms/SimpleTextField"

const PainScore = ({value, onChange}) => (
    <Grid item xs={12} md={6} lg={4} xl={3}>
          <SimpleTextField
            type="number"
            value={value}
            onChange={onChange}
            label="Pain Score (0 - 10)"
            InputProps={{
              inputProps: { min: 0, max: 10, step: 'any' },
            }}
          />
        </Grid>
)

export default PainScore